const RE = /^(.*?)(-?\d+(?:[.,]\d+)?)(\D*)$/;

const parse = (v) => {
    const m = RE.exec(String(v ?? "").trim());
    if (!m) return null;
    const num = m[2];
    const [intPart, frac = ""] = num.replace("-", "").split(/[.,]/);
    return {
        pre: m[1], suf: m[3], n: parseFloat(num.replace(",", ".")), dec: frac.length,
        sep: num.includes(",") ? "," : ".", width: intPart.length, pad: /^0\d/.test(intPart),
    };
};

const fmt = (p, n) => {
    let s = Math.abs(n).toFixed(p.dec);
    if (p.pad) {
        const [i, f] = s.split(".");
        s = i.padStart(p.width, "0") + (f !== undefined ? `.${f}` : "");
    }
    if (p.sep === ",") s = s.replace(".", ",");
    return p.pre + (n < 0 ? "-" : "") + s + p.suf;
};

// Excel-like fill: 1 value repeats; 2+ values with same prefix/suffix continue the numeric step.
// dir=1 continues after the last value, dir=-1 continues before the first (nearest first).
export function fillSeries(src, count, dir = 1) {
    if (!src.length || count <= 0) return [];
    if (src.length > 1) {
        const ps = src.map(parse);
        if (ps.every(Boolean) && ps.every((p) => p.pre === ps[0].pre && p.suf === ps[0].suf)) {
            const step = (ps[ps.length - 1].n - ps[0].n) / (ps.length - 1);
            const base = dir > 0 ? ps[ps.length - 1] : ps[0];
            const fp = { ...base, dec: Math.max(...ps.map((p) => p.dec)) };
            const allNumbers = src.every((v) => typeof v === "number");
            return Array.from({ length: count }, (_, k) => {
                const out = fmt(fp, base.n + dir * step * (k + 1));
                return allNumbers ? Number(out.replace(",", ".")) : out;
            });
        }
    }
    const n = src.length;
    return Array.from({ length: count }, (_, k) => (dir > 0 ? src[k % n] : src[n - 1 - (k % n)]));
}
